import React from 'react';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table';
import { Button } from '../ui/button';
import { Trash2, ClipboardList, Phone, Check, Pencil } from 'lucide-react';
import { formatDateTime } from '../../lib/utils';
import { brl } from './PesquisaUI';

const Pill = ({ children, cls = 'bg-slate-100 text-slate-600' }) => (
  <span className={`inline-block px-2 py-0.5 rounded text-xs ${cls}`}>{children}</span>
);

const contatoLink = (c) => {
  if (!c) return null;
  if (c.includes('@')) return <a href={`mailto:${c}`} className="text-slate-600 hover:text-primary">{c}</a>;
  const digits = c.replace(/\D/g, '');
  if (digits.length >= 10) {
    return (
      <a href={`https://wa.me/${digits.startsWith('55') ? digits : '55' + digits}`} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 text-slate-600 hover:text-green-600">
        <Phone className="w-3.5 h-3.5" />{c}
      </a>
    );
  }
  return <span className="text-slate-600">{c}</span>;
};

export const AdminPesquisaTable = ({ respostas, loading, onDelete, onEdit }) => (
  <div className="bg-white rounded-xl border border-slate-200 overflow-hidden">
    <div className="overflow-x-auto">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Data</TableHead>
            <TableHead>Local</TableHead>
            <TableHead>Unidade / Vínculo</TableHead>
            <TableHead>Plantão</TableHead>
            <TableHead>Regime</TableHead>
            <TableHead>Vale para</TableHead>
            <TableHead>Contato</TableHead>
            <TableHead className="w-[96px]">Ações</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {loading ? (
            Array(5).fill(0).map((_, i) => (
              <TableRow key={i}>
                {Array(8).fill(0).map((_, j) => <TableCell key={j}><div className="skeleton h-4 w-20" /></TableCell>)}
              </TableRow>
            ))
          ) : respostas.length > 0 ? (
            respostas.map((r) => (
              <TableRow key={r.id} data-testid={`pesquisa-row-${r.id}`}>
                <TableCell className="text-slate-500 text-sm whitespace-nowrap">
                  {formatDateTime(r.criado_em)}
                  {r.editado_em && <span className="block text-[10px] uppercase tracking-wide text-amber-600 font-semibold" data-testid={`pesquisa-editado-${r.id}`}>editado</span>}
                </TableCell>
                <TableCell className="text-slate-700 text-sm">{r.cidade} - {r.uf}</TableCell>
                <TableCell className="text-sm">
                  <p className="text-slate-700">{r.unidade}</p>
                  <Pill cls={r.vinculo === 'PJ' ? 'bg-blue-100 text-blue-700' : 'bg-amber-100 text-amber-700'}>{r.vinculo}</Pill>
                </TableCell>
                <TableCell className="text-sm">
                  <p className="font-semibold text-slate-900">{brl(r.valor)} <span className="text-slate-400 font-normal">/ {r.horas}h</span></p>
                  <p className="text-emerald-700 font-mono text-xs">{brl(r.valor_hora)}/h</p>
                </TableCell>
                <TableCell className="text-sm">
                  <p className="text-slate-700">{r.regime}</p>
                  <p className="text-xs text-slate-500">Produção: {r.producao}</p>
                  {r.valor_apendicectomia ? <p className="text-xs text-slate-500">Apendicectomia: {brl(r.valor_apendicectomia)}</p> : null}
                  {r.valor_acesso_venoso ? <p className="text-xs text-slate-500">Acesso venoso: {brl(r.valor_acesso_venoso)}</p> : null}
                </TableCell>
                <TableCell className="text-sm">
                  <p className="text-slate-700">{r.vale_para}</p>
                  {r.valor_feriado ? <p className="text-xs text-slate-500">Feriado: {brl(r.valor_feriado)}</p> : null}
                </TableCell>
                <TableCell className="text-sm">
                  {r.nome || r.contato ? (
                    <div>
                      <p className="font-medium text-slate-900">{r.nome || '—'}</p>
                      {contatoLink(r.contato)}
                      {r.aceita_contato && <p className="inline-flex items-center gap-1 text-xs text-emerald-700 mt-0.5"><Check className="w-3 h-3" />Aceita contato</p>}
                    </div>
                  ) : <span className="text-slate-400 text-xs">Anônimo</span>}
                </TableCell>
                <TableCell>
                  <div className="flex items-center">
                    <Button variant="ghost" size="icon" onClick={() => onEdit(r)} className="text-slate-500 hover:text-primary" data-testid={`pesquisa-edit-${r.id}`}>
                      <Pencil className="w-4 h-4" />
                    </Button>
                    <Button variant="ghost" size="icon" onClick={() => onDelete(r.id)} className="text-red-500 hover:text-red-600" data-testid={`pesquisa-delete-${r.id}`}>
                      <Trash2 className="w-4 h-4" />
                    </Button>
                  </div>
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={8} className="text-center py-12">
                <ClipboardList className="w-12 h-12 text-slate-300 mx-auto mb-4" />
                <p className="text-slate-500">Nenhuma resposta registrada ainda.</p>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </div>
  </div>
);
